export default "__VITE_ASSET__D8Bmy0tx__"